import { useEffect, useRef, useState } from "react";

const FALLBACK_PHRASE = "Please wait..";
const FALLBACK_FLAG = "/images/loader-pin.png";
const FALLBACK_SPIN = "/images/loader-spin.gif?v=logo";

export default function FlagLoader({ active, phrase = FALLBACK_PHRASE, image = FALLBACK_FLAG, minMs = 0 }) {
  const [phase, setPhase] = useState("run");
  const [count, setCount] = useState(0);
  const started = useRef(Date.now());

  useEffect(() => {
    if (active) {
      started.current = Date.now();
      setPhase("run");
      return undefined;
    }
    const wait = Math.max(0, minMs - (Date.now() - started.current));
    const hold = setTimeout(() => setPhase("leave"), wait);
    const done = setTimeout(() => setPhase("done"), wait + 480);
    return () => {
      clearTimeout(hold);
      clearTimeout(done);
    };
  }, [active, minMs]);

  useEffect(() => {
    if (phase === "done") return undefined;
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previous;
    };
  }, [phase]);

  useEffect(() => {
    if (phase === "done") return undefined;
    const line = phrase || FALLBACK_PHRASE;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) {
      setCount(line.length);
      return undefined;
    }
    let typed = 0;
    let pause = 0;
    setCount(0);
    const timer = setInterval(() => {
      if (typed < line.length) {
        typed += 1;
        setCount(typed);
        return;
      }
      pause += 1;
      if (pause > 10) {
        typed = 0;
        pause = 0;
        setCount(0);
      }
    }, 95);
    return () => clearInterval(timer);
  }, [phase === "done", phrase]);

  if (phase === "done") return null;

  const line = phrase || FALLBACK_PHRASE;
  const flag = image || FALLBACK_FLAG;

  return (
    <div className={`flag-loader${phase === "leave" ? " is-leaving" : ""}`} role="status">
      <span className="flag-sr">{line}</span>
      <div className="flag-stage" aria-hidden="true">
        <img className="loader-spin" src={FALLBACK_SPIN} alt="" />
        {flag ? <img className="lanka-flag" src={flag} alt="" /> : null}
      </div>
      <p className="flag-loader-text" aria-hidden="true">
        <span>{line.slice(0, count)}</span>
        <span className="flag-caret" />
        <span className="flag-rest">{line.slice(count)}</span>
      </p>
    </div>
  );
}

